import { Section } from "./data-types";

export const EventsPast: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 1
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Past Events",
						content: () => [
							<div style="min-height: 320px; height: 70vh;">
								<iframe
									sandbox="allow-scripts allow-same-origin"
									title="Geography and geosciences in the school curriculum: keynote lecture"
									src="https://www.youtube.com/embed/gd0o_rAvDG8"
									width="100%"
									height="100%"
									frameborder="0"
									webkitallowfullscreen
									mozallowfullscreen
									allowfullscreen></iframe>
							</div>
						]
					}
				},
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Geography and Geosciences in the School Curriculum",
						content: () => [
							<p>
								On Wednesday, 19 November 2025 the Royal Irish Academy welcomed Professor David Kaplan,
								past-president of the American Society of Geographers, to deliver the keynote address at an
								evening panel event exploring the future of Geography and Geosciences education. Co-organised by
								the Academy’s Geography and Geosciences Committee and the Geographical Society of Ireland, the
								event aimed to draw attention to the importance of geography and geosciences in evolving school
								curricula, across primary, post-primary and higher education, and to highlight how these
								disciplines can support and enhance the renewed focus on education around climate action and
								sustainable development.
							</p>,
							<p>
								In her opening remarks, Dr Karen Keaveney, President of the Geographical Society of Ireland
								said:
							</p>,
							<blockquote>
								“The new climate action and sustainable development subject really brings the role of
								Geographers to the fore, considering our history and understanding of place-based transitions
								and responses to climate change and climate crises. With this in mind we brought together our
								speaker and our panellists for this event focused on the geography and geosciences curriculum.”
							</blockquote>,
							<p>
								Following the keynote, Professor Kaplan was joined on stage by four panellists for a broader
								discussion about geography and geosciences education in an Irish context. This discussion was
								chair by Dr Karen Keaveney and featured Dr Alma Clavin from University of Galway, Dr Susan Pike
								from Trinity College Dublin, Dr Siobhán Power from Geological Survey Ireland, and Brendan
								O'Sullivan, a Post-Primary Inspector and Link Inspector for Geography at the Department of
								Education and Youth.
							</p>,
							<p>
								The panel discussion touched on the critical competencies instilled in students of geography,
								the critical need for geography and geoscience graduates in industry, and the need to spread
								awareness of the discipline of geography in all of its diversity.
							</p>
						]
					}
				}
			]
		}
	]
};
